<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="h-full flex">
      <div class="m-auto text-blue-200">
        <div class="text-center items-center p-6">
          <svg-vue class="h-full w-full md:h-48 mb-6" icon="undraw.page-not-found"></svg-vue>
          <div class="font-semibold text-2xl">
            {{ $t('Whoops! Looks like you got lost') }}
          </div>
          <div>{{ $t("We couldn't find what you were looking for") }}</div>
          <div class="mt-6 text-center">
            <router-link
              active-class
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded focus:outline-none focus:shadow-outline"
              exact-active-class
              to="/admin/dashboard"
              >{{ $t('Go home') }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'not-found',
  metaInfo() {
    return {
      title: this.$i18n.t('Not found'),
    };
  },
};
</script>
